import { View, Text, Pressable, Linking } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { TriangleAlert } from "lucide-react-native";
import { EMBER } from "../onboarding/theme";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

type Props = {
  title?: string;
  message?: string;
  onReload?: () => void;
};

export function ErrorScreen({
  title = "Something went wrong",
  message = "We encountered an unexpected issue. Please try again.",
  onReload,
}: Props) {
  const capturePress = usePressCapture("ErrorScreen");
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: EMBER.colors.surface,
      }}
    >
      <SafeAreaView
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          paddingHorizontal: 32,
        }}
      >
        <TriangleAlert size={40} color={EMBER.colors.coral} strokeWidth={1.5} />

        <Text
          className="font-dm-sans"
          style={{
            fontSize: 22,
            fontWeight: "700",
            color: EMBER.colors.text,
            textAlign: "center",
            marginTop: 20,
            marginBottom: 8,
          }}
        >
          {title}
        </Text>

        <Text
          className="font-dm-sans"
          style={{
            fontSize: 14,
            color: EMBER.colors.textMid,
            textAlign: "center",
            lineHeight: 20,
            maxWidth: 300,
            marginBottom: 32,
          }}
        >
          {message}
        </Text>

        {onReload && (
          <Pressable
            onPress={() => {
              capturePress(pressLabel("Reload"));
              onReload();
            }}
            style={{
              backgroundColor: EMBER.colors.warm,
              borderRadius: 12,
              paddingVertical: 14,
              paddingHorizontal: 32,
              marginBottom: 12,
            }}
          >
            <Text
              className="font-dm-sans"
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: "#FFFFFF",
              }}
            >
              Reload
            </Text>
          </Pressable>
        )}

        <Pressable
          onPress={() => {
            capturePress(pressLabel("Contact Support"));
            void Linking.openURL("mailto:support@louise.life");
          }}
          style={{
            paddingVertical: 10,
            paddingHorizontal: 20,
          }}
        >
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 13,
              color: EMBER.colors.textLight,
            }}
          >
            Contact Support
          </Text>
        </Pressable>
      </SafeAreaView>
    </View>
  );
}
